import log from 'Utilities/log';
const handleMessage = (event, resolve) => {
    try {
        const data = JSON.parse(event.data);
        if (data.type === 'AUTH_TOKEN' && data.token) {
            resolve(data.token);
        }
    }
    catch {
        // Expected during initial render - token not yet sent
        log.info('Waiting for token...');
    }
};
export const waitForToken = (queryToken) => {
    return new Promise((resolve, reject) => {
        if (queryToken) {
            resolve(queryToken);
            return;
        }
        // Listener for browser
        window.addEventListener('message', (event) => {
            if (event.origin === window.location.origin) {
                handleMessage(event, resolve);
            }
        });
        // Listener for React Native Webview
        document.addEventListener('message', (event) => handleMessage(event, resolve));
        setTimeout(() => {
            reject({ status: 401, message: 'Token timeout' });
        }, 20000);
    });
};
